import { PointCardType } from 'types/pointCard'

export const FETCH_POINT_CARD = 'FETCH_POINT_CARD'
export const fetchPointCardAction = (pointCard: PointCardType) => {
  return {
    type: 'FETCH_POINT_CARD',
    payload: pointCard,
  }
}

export const INIT_POINT_CARD = 'INIT_POINT_CARD'
export const initPointCardAction = () => {
  return {
    type: 'INIT_POINT_CARD',
    payload: null,
  }
}
